import React from 'react';
import PropTypes from 'prop-types';

export const TextArea = ({ name, maxLength, rows, placeHolder, value, onChange, isRequired, error, onBlur, label }) => {
    const errorClass = error && error.length > 0 ? 'c-form__field--has-error' : '';
    const placeHolderText = isRequired ? `${placeHolder}*` : placeHolder;

    return (
        <div className={`c-form__field c-form__field--default ${errorClass}`}>
            <label className="c-form__label c-form__label--textarea">{label}</label>
            <textarea
                name={name}
                maxLength={maxLength}
                rows={rows}
                className="c-form__textarea"
                placeholder={placeHolderText}
                value={value}
                onChange={onChange}
                required={isRequired}
                onBlur={onBlur}
            />
            {error && <div className="field-error">{error}</div>}
        </div>
    );
};

TextArea.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    isRequired: PropTypes.bool,
    placeHolder: PropTypes.string,
    value: PropTypes.string,
    error: PropTypes.string,
    onBlur: PropTypes.func
};

TextArea.defaultProps = {
    isRequired: false,
    placeHolder: '',
    value: '',
    error: '',
    onBlur: () => { }
};
